/**
 * Updated on 12/20/2024
 * This file contains the mapping of utility names to their respective utility names.
 * - minimizes the errors that could occure from free text input.
 *
 * @example custUtility = utilitiesMap['Duke Energy Carolinas - North Carolina']
 */

export default {
  "Appalachian Power Co": "Appalachian Power Co",
  "Mecklenburg Electric Cooperative": "Mecklenburg Electric Cooperative",
  "Arizona Public Service Company (APS)":
    "Arizona Public Service Company (APS)",
  "Salt River Project (SRP)": "Salt River Project (SRP)",
  "Black Hills Energy - Colorado": "Black Hills Energy - Colorado",
  "City of Loveland Water and Power Utility":
    "City of Loveland Water and Power Utility",
  "Colorado Springs Utilities": "Colorado Springs Utilities",
  "CORE Electric Cooperative": "CORE Electric Cooperative",
  "Estes Park Light & Power": "Estes Park Light & Power",
  "Fort Collins Utilities (FCU)": "Fort Collins Utilities (FCU)",
  "Fountain Department of Utilities": "Fountain Department of Utilities",
  "GVP-Grand Valley Power (z)": "GVP-Grand Valley Power (z)",
  "Holy Cross Energy": "Holy Cross Energy",
  "K. C. Electric Association": "K. C. Electric Association",
  "La Plata Electric Association Inc (z)":
    "La Plata Electric Association Inc (z)",
  "Longmont Power": "Longmont Power",
  "Morgan County REA": "Morgan County REA",
  "Mountain Parks Electric": "Mountain Parks Electric",
  "Mountain View Electric Association (MVEA)":
    "Mountain View Electric Association (MVEA)",
  "Poudre Valley Rural Electric Assc (PVREA)":
    "Poudre Valley Rural Electric Assc (PVREA)",
  "San Isabel Electric": "San Isabel Electric",
  "San Luis Valley Rural Electric Cooperative":
    "San Luis Valley Rural Electric Cooperative",
  "Sangre De Cristo Electric Association, Inc.  z":
    "Sangre De Cristo Electric Association, Inc.  z",
  "Southeast Colorado Power Association (SECPA)":
    "Southeast Colorado Power Association (SECPA)",
  "United Power": "United Power",
  "Xcel Energy": "Xcel Energy",
  "Yampa Valley Electric Association (z)":
    "Yampa Valley Electric Association (z)",
  z: "z",
  "Duke Energy - Fl": "Duke Energy - Fl",
  "Florida Power and Light - FL": "Florida Power and Light - FL",
  "Kissimmee Utility Authority - FL": "Kissimmee Utility Authority - FL",
  "Orlando Utility Commission - FL": "Orlando Utility Commission - FL",
  "Sumter Electric Cooperative - FL": "Sumter Electric Cooperative - FL",
  "Tampa Electric Company - FL": "Tampa Electric Company - FL",
  "Winter Park Utility - FL": "Winter Park Utility - FL",
  "Idaho Power (z)": "Idaho Power (z)",
  "Rocky Mountain Power - Idaho (z)": "Rocky Mountain Power - Idaho (z)",
  "Ameren Illinois": "Ameren Illinois",
  "Buckeye REC": "Buckeye REC",
  "City of Batavia Utility": "City of Batavia Utility",
  "City of St. Charles": "City of St. Charles",
  "Commonwealth Edison (ComEd)": "Commonwealth Edison (ComEd)",
  "MidAmerican Energy Company": "MidAmerican Energy Company",
  "Mt. Carmel Public Utility Co": "Mt. Carmel Public Utility Co",
  "Naperville Utility": "Naperville Utility",
  "Rock Energy Co-Op": "Rock Energy Co-Op",
  "St. Charles Municipal Electric Utility":
    "St. Charles Municipal Electric Utility",
  "Sedgwick County Electric Cooperative":
    "Sedgwick County Electric Cooperative",
  "Ameren Missouri": "Ameren Missouri",
  Evergy: "Evergy",
  "Boulder City Utility": "Boulder City Utility",
  "NV Energy": "NV Energy",
  "Overton Power (z)": "Overton Power (z)",
  "Valley Electric Association (VEA)": "Valley Electric Association (VEA)",
  "Atlantic City Electric": "Atlantic City Electric",
  "Central New Mexico Electric Coop (CNMEC)":
    "Central New Mexico Electric Coop (CNMEC)",
  "Continental Divide Electric Cooperative (CDEC)":
    "Continental Divide Electric Cooperative (CDEC)",
  "Jemez Mountains Electric Coop (JMEC)":
    "Jemez Mountains Electric Coop (JMEC)",
  "Kit Carson Electric Coop": "Kit Carson Electric Coop",
  "Los Alamos County Utilities": "Los Alamos County Utilities",
  "Mora San Miguel Electric Cooperative":
    "Mora San Miguel Electric Cooperative",
  "Northern Rio Arriba Electric (NORA) (z)":
    "Northern Rio Arriba Electric (NORA) (z)",
  "PNM - Public Service Company of New Mexico":
    "PNM - Public Service Company of New Mexico",
  "Sierra Electric Coop (SEC) (z)": "Sierra Electric Coop (SEC) (z)",
  "Socorro Electric Cooperative": "Socorro Electric Cooperative",
  "Albemarle EMC NO NET METERING, DO NOT USE":
    "Albemarle EMC NO NET METERING, DO NOT USE",
  "Blue Ridge Electric Cooperative, INC.":
    "Blue Ridge Electric Cooperative, INC.",
  "City of Concord Utility": "City of Concord Utility",
  "City of Elizabeth Utility (z)": "City of Elizabeth Utility (z)",
  "City of High Point Utility (z)": "City of High Point Utility (z)",
  "City of Monroe Energy Services": "City of Monroe Energy Services",
  "Clayton Public Power (z)": "Clayton Public Power (z)",
  "Dominion Energy North Carolina": "Dominion Energy North Carolina",
  "Duke Energy Carolinas - North Carolina":
    "Duke Energy Carolinas - North Carolina",
  "Duke Energy Progress - North Carolina":
    "Duke Energy Progress - North Carolina",
  EnergyUnited: "EnergyUnited",
  "Lumbee River EMC (z)": "Lumbee River EMC (z)",
  "Piedmont Electric Member Coop (PEMC)":
    "Piedmont Electric Member Coop (PEMC)",
  "Rutherford Electric Membership Corporation":
    "Rutherford Electric Membership Corporation",
  "South River Electric Membership Corp.":
    "South River Electric Membership Corp.",
  "Town of Apex Utilities Services": "Town of Apex Utilities Services",
  "Town of Clayton": "Town of Clayton",
  "Tri-County Electric Membership Corp (TCEMC)":
    "Tri-County Electric Membership Corp (TCEMC)",
  "Union Power Cooperative": "Union Power Cooperative",
  "Wake Electric Membership Corporation":
    "Wake Electric Membership Corporation",
  "AEP Ohio": "AEP Ohio",
  "AES Ohio": "AES Ohio",
  "Butler Rural Electric Cooperative, Inc.":
    "Butler Rural Electric Cooperative, Inc.",
  "City of Lebanon Electric Department": "City of Lebanon Electric Department",
  "City of Westerville Electric": "City of Westerville Electric",
  "Consolidated Electric Cooperative (CEC)":
    "Consolidated Electric Cooperative (CEC)",
  "Duke Energy Ohio": "Duke Energy Ohio",
  "First Energy": "First Energy",
  "Hamilton Utilities (DO NOT USE)": "Hamilton Utilities (DO NOT USE)",
  "Logan County Electric Cooperative": "Logan County Electric Cooperative",
  "Pioneer Electric Cooperative": "Pioneer Electric Cooperative",
  "South Central Power Company": "South Central Power Company",
  "The Energy Cooperative - Ohio": "The Energy Cooperative - Ohio",
  "Tipp City Electric": "Tipp City Electric",
  "Union Rural Electric Cooperative": "Union Rural Electric Cooperative",
  "Village of Yellow Springs Utilities": "Village of Yellow Springs Utilities",
  "CKenergy Electric Co-op": "CKenergy Electric Co-op",
  "Claremore Electric": "Claremore Electric",
  "East Central Oklahoma Electric Cooperative":
    "East Central Oklahoma Electric Cooperative",
  "Edmond Electric": "Edmond Electric",
  "Indian Electric Cooperative": "Indian Electric Cooperative",
  "Lake Region Electric Cooperative (LREC)":
    "Lake Region Electric Cooperative (LREC)",
  NUll: "NUll",
  "Oklahoma Electric Cooperative": "Oklahoma Electric Cooperative",
  "Oklahoma Gas and Electric (OG&E)": "Oklahoma Gas and Electric (OG&E)",
  "Public Service Company of Oklahoma (PSO)":
    "Public Service Company of Oklahoma (PSO)",
  "Verdigris Valley Electric Cooperative":
    "Verdigris Valley Electric Cooperative",
  "Canby Utility (CU)": "Canby Utility (CU)",
  "Central Electric Cooperative Inc. (CEC) (z)":
    "Central Electric Cooperative Inc. (CEC) (z)",
  "City of Monmouth Utilities": "City of Monmouth Utilities",
  "Columbia River": "Columbia River",
  "Columbia River PUD": "Columbia River PUD",
  "Consumers Power Inc. (CPI)": "Consumers Power Inc. (CPI)",
  "Forest Grove Light & Power (FGLP)": "Forest Grove Light & Power (FGLP)",
  "Hood River Electric Coop (HREC)": "Hood River Electric Coop (HREC)",
  "McMinnville Water & Light": "McMinnville Water & Light",
  "Pacific Power": "Pacific Power",
  "Portland General Electric (PGE)": "Portland General Electric (PGE)",
  "Salem Electric": "Salem Electric",
  "Springfield Utility Board": "Springfield Utility Board",
  "Wasco Electric Cooperative": "Wasco Electric Cooperative",
  "West Oregon Electric Coop (WOEC)": "West Oregon Electric Coop (WOEC)",
  "Duke Energy Carolinas - South Carolina":
    "Duke Energy Carolinas - South Carolina",
  "Duke Energy Progress - South Carolina":
    "Duke Energy Progress - South Carolina",
  "Lynches River Electric Cooperative": "Lynches River Electric Cooperative",
  "Pee Dee Electric (z)": "Pee Dee Electric (z)",
  "Rock Hill Electric": "Rock Hill Electric",
  "South Carolina Electric & Gas (Dominion Energy SC)":
    "South Carolina Electric & Gas (Dominion Energy SC)",
  "York Electric Cooperative": "York Electric Cooperative",
  "4Change Energy (Oncor)": "4Change Energy (Oncor)",
  "AEP Texas": "AEP Texas",
  "Austin Energy": "Austin Energy",
  "Bandera Electric Cooperative": "Bandera Electric Cooperative",
  "Bartlett Electric Cooperative (BEC)": "Bartlett Electric Cooperative (BEC)",
  "Bluebonnet Electric Cooperative": "Bluebonnet Electric Cooperative",
  "Castroville Utility System": "Castroville Utility System",
  "CenterPoint Energy": "CenterPoint Energy",
  "Central Texas Electric Co-op (z)": "Central Texas Electric Co-op (z)",
  "Champion Energy Services": "Champion Energy Services",
  "Chariot Energy, LLC": "Chariot Energy, LLC",
  "Cirro Energy (Oncor)": "Cirro Energy (Oncor)",
  "City of Boerne Public Utilities": "City of Boerne Public Utilities",
  "City of Georgetown Utility": "City of Georgetown Utility",
  "City of San Marcos Utility (SMEU A.K.A. SMTX Utilities)":
    "City of San Marcos Utility (SMEU A.K.A. SMTX Utilities)",
  "City of Seguin Utilities": "City of Seguin Utilities",
  "City Public Service (CPS Energy)": "City Public Service (CPS Energy)",
  "College Station Utilities (z)": "College Station Utilities (z)",
  "Constellation Energy (Centerpoint)": "Constellation Energy (Centerpoint)",
  "CoServ Electric": "CoServ Electric",
  "Denton Municipal Electric": "Denton Municipal Electric",
  "Direct Energy": "Direct Energy",
  "Discount Power": "Discount Power",
  "Entergy Texas": "Entergy Texas",
  "Fannin County Electric Coop (FCEC) (z)":
    "Fannin County Electric Coop (FCEC) (z)",
  "Farmers Electric Cooperative": "Farmers Electric Cooperative",
  "Floresville Electric Light & Power (FEL&P)":
    "Floresville Electric Light & Power (FEL&P)",
  "Frontier Utilities Inc": "Frontier Utilities Inc",
  "Garland Power and Light": "Garland Power and Light",
  "Geenville Electric Utility System (GEUS)":
    "Geenville Electric Utility System (GEUS)",
  "Gexa Energy": "Gexa Energy",
  "Good Charlie Energy": "Good Charlie Energy",
  "Grayson-Collin Electric Cooperative (GCEC)":
    "Grayson-Collin Electric Cooperative (GCEC)",
  "Greenville Electric Utility System (GEUS) (z)":
    "Greenville Electric Utility System (GEUS) (z)",
  "Guadalupe Valley Electric Cooperative (GVEC)":
    "Guadalupe Valley Electric Cooperative (GVEC)",
  "HILCO Electric Coop": "HILCO Electric Coop",
  "IronHorse Power Services (Oncor)": "IronHorse Power Services (Oncor)",
  "Just Energy (Oncor)": "Just Energy (Oncor)",
  "Karnes Electric Cooperative, Inc": "Karnes Electric Cooperative, Inc",
  "Lampasas Public Utilities": "Lampasas Public Utilities",
  "Lone Star Energy": "Lone Star Energy",
  "Medina Electric Cooperative": "Medina Electric Cooperative",
  "MidSouth Electric": "MidSouth Electric",
  "MidSouth Electric Co-op": "MidSouth Electric Co-op",
  "New Braunfels Utilities (NBU)": "New Braunfels Utilities (NBU)",
  "New Power TX": "New Power TX",
  Oncor: "Oncor",
  "Pedernales Electric Cooperative (PEC)":
    "Pedernales Electric Cooperative (PEC)",
  Powernext: "Powernext",
  "Pulse Power (Oncor)": "Pulse Power (Oncor)",
  "Reliant (Oncor)": "Reliant (Oncor)",
  "Reliant Energy Retail Holdings LLC": "Reliant Energy Retail Holdings LLC",
  "Rhythm Energy": "Rhythm Energy",
  "Sam Houston Electric Coop (SHEC)": "Sam Houston Electric Coop (SHEC)",
  "San Bernard Electric Cooperative (SBEC)":
    "San Bernard Electric Cooperative (SBEC)",
  "Stream Energy": "Stream Energy",
  "Tara Energy": "Tara Energy",
  "Texas-New Mexico Power (TNMP)": "Texas-New Mexico Power (TNMP)",
  "Tri-County Electric Cooperative - Texas":
    "Tri-County Electric Cooperative - Texas",
  "TriEagle Energy LP": "TriEagle Energy LP",
  "Trinity Valley Electric Co-op (TVEC)":
    "Trinity Valley Electric Co-op (TVEC)",
  "TXU Energy": "TXU Energy",
  "United Cooperative Services (UCS)": "United Cooperative Services (UCS)",
  "Veteran Energy (Oncor)": "Veteran Energy (Oncor)",
  "Weatherford Municipal Utility System (WMUS)":
    "Weatherford Municipal Utility System (WMUS)",
  "Windrose Energy (Oncor)": "Windrose Energy (Oncor)",
  "Wise Electric Cooperative": "Wise Electric Cooperative",
  "Bountiful City Electric": "Bountiful City Electric",
  "City of Murray Utility": "City of Murray Utility",
  "City of Payson Utility": "City of Payson Utility",
  "City of St. George Utility": "City of St. George Utility",
  "Heber Light and Power": "Heber Light and Power",
  "Kaysville City Power": "Kaysville City Power",
  "Lehi City Power": "Lehi City Power",
  "Logan City Light & Power": "Logan City Light & Power",
  "Mt. Pleasant Power": "Mt. Pleasant Power",
  "Nephi City Power": "Nephi City Power",
  "Provo City Utilities": "Provo City Utilities",
  "Rocky Mountain Power - Utah": "Rocky Mountain Power - Utah",
  "Salem City Utility": "Salem City Utility",
  "Spanish Fork Utility": "Spanish Fork Utility",
  "Springville Power": "Springville Power",
  "St George Utilities": "St George Utilities",
  "Strawberry Electric/South Utah Valley Electric Service District":
    "Strawberry Electric/South Utah Valley Electric Service District",
  "A&N Electric Cooperative": "A&N Electric Cooperative",
  "AA TEST": "AA TEST",
  "Central Virginia Electric Cooperative (CVEC)":
    "Central Virginia Electric Cooperative (CVEC)",
  "City of Manassas Electric Utility (MEU)":
    "City of Manassas Electric Utility (MEU)",
  "Community Electric Cooperative": "Community Electric Cooperative",
  "Danville Utilities": "Danville Utilities",
  "Dominion Energy Virginia": "Dominion Energy Virginia",
  "Franklin Power & Light": "Franklin Power & Light",
  "Harrisonburg Electric Commission": "Harrisonburg Electric Commission",
  "Northern Neck Electric Cooperative Inc":
    "Northern Neck Electric Cooperative Inc",
  "Northern Virginia Electric Coop (NOVEC)":
    "Northern Virginia Electric Coop (NOVEC)",
  "Prince George Electric Cooperative": "Prince George Electric Cooperative",
  "Rappahannock Electric Cooperative": "Rappahannock Electric Cooperative",
  "Roanoke Electric Cooperative": "Roanoke Electric Cooperative",
  "Shenandoah Valley Electric Coop (SVEC)":
    "Shenandoah Valley Electric Coop (SVEC)",
  "Southside Electric Cooperative": "Southside Electric Cooperative",
  "Southside Electric Cooperative Inc": "Southside Electric Cooperative Inc",
  "Town of Culpeper Utilities": "Town of Culpeper Utilities",
  "Clark Public Utilities (CPUD)": "Clark Public Utilities (CPUD)",
  "Black Hills Energy - Wyoming": "Black Hills Energy - Wyoming",
};
